import {renderElement} from "./utils/common";
import {ListActions} from "./utils/consts";

export const suggestAddres = () => {
  const addressFillNode = document.querySelector(`.js-fill-adress`);

  const BoundTypes = {
    REGION: `region`,
    CITY: `city`,
    STREET: `street`,
    HOUSE: `house`,
  };

  const adressState = {
    region: null,
    city: null,
    postal: null,
    street: null,
    house: null,
  };

  const createEvent = (name) => {
    const event = new Event(name, {bubbles: true, cancelable: true});
    return event;
  };

  const getSuggestionItemTemplate = ({
    value,
    data: {region, city, house, postal_code, street, block, block_type},
  }) => `<li class="suggestion__item js-suggestion-item"
    ${region ? `data-region="${region}"` : ``} ${postal_code ? `data-postal="${postal_code}"` : ``}
    ${city ? `data-city="${city}"` : ``} ${house ? `data-house="${house} ${block ? `${block_type} ${block}` : ``}"` : ``}
    ${street ? `data-street="${street}"` : ``}>
    ${value}
  </li>`;

  const fetchSuggestData = async (query, type) => {
    const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
    const token = "877a21dcd1b9e7c03d457821f5d96f8086a7416b";

    const locations = [adressState];

    const queryObj = {
      query,
      from_bound: {value: type},
      to_bound: {value: type},
      locations,
    };

    const options = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + token,
      },
      body: JSON.stringify(queryObj),
    };

    const result = await fetch(url, options)
      .then((response) => response.json())
      .then((data) => data)
      .catch((error) => console.log("error", error));

    return result;
  };

  if (addressFillNode) {
    const inputsElements = addressFillNode.querySelectorAll(`.js-fill-input`);

    const regionInput = addressFillNode.querySelector(`.js-fill-region`);
    const cityInput = addressFillNode.querySelector(`.js-fill-city`);
    const streetInput = addressFillNode.querySelector(`.js-fill-street`);
    const houseInput = addressFillNode.querySelector(`.js-fill-house`);
    const postalInput = addressFillNode.querySelector(`.js-fill-postal`);

    const setAdress = (element) => {
      regionInput.value = element.dataset.region ? element.dataset.region : ``;
      cityInput.value = element.dataset.city ? element.dataset.city : ``;
      streetInput.value = element.dataset.street ? element.dataset.street : ``;
      houseInput.value = element.dataset.house ? element.dataset.house : ``;
      postalInput.value = element.dataset.postal ? element.dataset.postal : ``;

      adressState.region = element.dataset.region ? element.dataset.region : null;
      adressState.city = element.dataset.city ? element.dataset.city : null;
      adressState.street = element.dataset.street ? element.dataset.street : null;
      adressState.house = element.dataset.house ? element.dataset.house : null;
      adressState.postal = element.dataset.postal ? element.dataset.postal : null;
    };

    inputsElements.forEach((input) => {
      const parent = input.closest(`label`);
      const suggestionListElement = parent.querySelector(`.js-suggestion-list`) || parent.nextElementSibling;

      const setVisibleSugestionList = (list, action) => {
        switch (action) {
          case ListActions.SHOW:
            list.classList.add(`show`);
            document.addEventListener(`click`, withoutListClickHandler);
            break;
          case ListActions.HIDE:
            list.classList.remove(`show`);
            document.removeEventListener(`click`, withoutListClickHandler);
            break;
        }
        list.querySelectorAll(`.js-suggestion-item`).forEach((element) => element.remove());
      };

      const withoutListClickHandler = (evt) => {
        if (evt.target.closest(`.js-suggestion-list`) !== suggestionListElement) {
          suggestionListElement.classList.remove(`show`);
        }
      };

      const onSuggestionListClick = (evt) => {
        if (evt.target.classList.contains(`js-suggestion-item`) || evt.target.closest(`.js-suggestion-item`)) {
          setAdress(evt.target);
          setVisibleSugestionList(evt.currentTarget, ListActions.HIDE);
          input.dispatchEvent(createEvent(`change`));
        }
      };

      const onTextFieldInput = async () => {
        let type;
        switch (true) {
          case input.classList.contains(`js-fill-region`):
            type = BoundTypes.REGION;
            break;
          case input.classList.contains(`js-fill-city`):
            type = BoundTypes.CITY;
            break;
          case input.classList.contains(`js-fill-street`):
            type = BoundTypes.STREET;
            break;
          case input.classList.contains(`js-fill-house`):
            type = BoundTypes.HOUSE;
            break;
        }

        switch (type) {
          case BoundTypes.STREET:
            adressState.street = null;
            adressState.house = null;
            break;
          case BoundTypes.HOUSE:
            adressState.house = null;
            break;
          default:
            adressState.region = null;
            adressState.city = null;
            adressState.street = null;
            adressState.house = null;
        }

        const results = await fetchSuggestData(input.value, type);

        if (results.suggestions.length) {
          setVisibleSugestionList(suggestionListElement, ListActions.SHOW);
          results.suggestions.forEach((result) => {
            renderElement(suggestionListElement, getSuggestionItemTemplate(result));
          });
        } else {
          setVisibleSugestionList(suggestionListElement, ListActions.HIDE);
        }
      };

      suggestionListElement.addEventListener(`click`, onSuggestionListClick);

      input.addEventListener(`input`, onTextFieldInput);
    });
  }
};
